import axios from "axios";

//  const API_URL = 'http://localhost/games-p/stock-admin/api/ScoreApi.php';
const API_URL =  process.env.REACT_APP_SERVICE_API;
console.log("API_URL----",API_URL);

// Insert Score (PHP checks for duplicate automatically)
export const checkTeams = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "check",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Insert error:", err);
    return { status: "error", message: err.message };
  }
};
